export const SCR_V2_SUMMARY_PRINT_STYLES = `.scr-v2-summary-print-view {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  color: #0f172a;
  line-height: 1.5;
  padding: 0;
  margin: 0;
  width: 100% !important;
  max-width: 100% !important;
}

.scr-v2-summary-print-view * {
  box-sizing: border-box;
}

.scr-v2-print-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.25rem;
  margin-bottom: 1.25rem;
  width: 100%;
}

.scr-v2-print-header__title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
}

.scr-v2-print-header__meta {
  text-align: right;
  flex-shrink: 0;
  font-size: 15px;
}

.scr-v2-print-status {
  display: inline-block;
  padding: 0.3rem 0.7rem;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 0.3rem;
}

.scr-v2-print-status--open {
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
}

.scr-v2-print-status--finalized {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.scr-v2-print-info-strip {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem 1.5rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.35rem;
  padding: 1.15rem 1.25rem;
  margin-bottom: 1.25rem;
  width: 100%;
}

.scr-v2-print-info-item__label {
  display: block;
  font-size: 13px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
  margin-bottom: 0.25rem;
  font-weight: 600;
}

.scr-v2-print-info-item__value {
  display: block;
  font-size: 16px;
  font-weight: 700;
  word-break: break-word;
  color: #0f172a;
}

.scr-v2-print-info-item__sub {
  display: block;
  font-size: 14px;
  color: #64748b;
  margin-top: 0.15rem;
  font-weight: 500;
}

.scr-v2-print-kpi-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
  margin-bottom: 1.25rem;
  width: 100%;
}

.scr-v2-print-kpi {
  border: 1px solid #e2e8f0;
  border-radius: 0.35rem;
  padding: 1.1rem 1.15rem;
  min-height: 5.75rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.scr-v2-print-kpi__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.45rem;
}

.scr-v2-print-kpi__title {
  font-size: 13px;
  color: #64748b;
  font-weight: 600;
  margin: 0;
  min-width: 0;
  white-space: nowrap;
}

.scr-v2-print-kpi__detail {
  font-size: 12px;
  color: #475569;
  text-align: right;
  margin: 0;
  flex-shrink: 0;
  max-width: 48%;
  line-height: 1.25;
  font-weight: 500;
}

.scr-v2-print-kpi__amount {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin-top: auto;
}

.scr-v2-print-middle {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.1rem;
  align-items: stretch;
  margin-bottom: 1.25rem;
  width: 100%;
}

.scr-v2-print-left {
  display: flex;
  min-height: 100%;
  width: 100%;
}

.scr-v2-print-left .scr-v2-print-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.scr-v2-print-left .scr-v2-print-panel__body {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.scr-v2-print-right-stack {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}

.scr-v2-print-efficiency {
  border: 1px solid #e2e8f0;
  border-radius: 0.35rem;
  padding: 1.25rem 1.2rem;
  text-align: center;
}

.scr-v2-print-efficiency__label {
  font-size: 13px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #64748b;
  margin-bottom: 0.4rem;
  font-weight: 600;
}

.scr-v2-print-efficiency__rate {
  font-size: 36px;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: 0.4rem;
}

.scr-v2-print-efficiency__detail {
  font-size: 14px;
  color: #64748b;
}

.scr-v2-print-panel {
  border: 1px solid #e2e8f0;
  border-radius: 0.35rem;
  overflow: hidden;
  width: 100%;
}

.scr-v2-print-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  background: #f8fafc;
}

.scr-v2-print-panel__title {
  font-size: 15px;
  font-weight: 700;
}

.scr-v2-print-panel__badge {
  font-size: 13px;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  padding: 0.18rem 0.5rem;
  color: #475569;
  white-space: nowrap;
  background: #fff;
  margin-left: auto;
  font-weight: 600;
}

.scr-v2-print-panel__body {
  padding: 0.9rem 1rem;
}

.scr-v2-print-amount-rows {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
}

.scr-v2-print-amount-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 9rem;
  align-items: center;
  column-gap: 1.1rem;
  margin-bottom: 0.55rem;
}

.scr-v2-print-amount-row--strong {
  border-top: 1px solid #e2e8f0;
  padding-top: 0.65rem;
  margin-bottom: 0;
}

.scr-v2-print-left .scr-v2-print-amount-row--strong {
  margin-top: auto;
}

.scr-v2-print-amount-row__label {
  font-size: 15px;
  color: #64748b;
  text-align: left;
}

.scr-v2-print-amount-row__label--strong {
  font-weight: 700;
  color: #0f172a;
}

.scr-v2-print-amount-row__value {
  font-size: 15px;
  text-align: right;
  white-space: nowrap;
}

.scr-v2-print-table {
  width: 100% !important;
  border-collapse: collapse;
  table-layout: fixed;
}

.scr-v2-print-table th,
.scr-v2-print-table td {
  padding: 0.65rem 0.85rem;
  font-size: 15px;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

.scr-v2-print-table th:nth-child(1),
.scr-v2-print-table td:nth-child(1) {
  width: 58%;
  text-align: left;
}

.scr-v2-print-table th:nth-child(2),
.scr-v2-print-table td:nth-child(2) {
  width: 14%;
  text-align: center;
}

.scr-v2-print-table th:nth-child(3),
.scr-v2-print-table td:nth-child(3) {
  width: 28%;
  text-align: right;
}

.scr-v2-print-table thead th {
  background: #f8fafc;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
}

.scr-v2-print-payment-group td {
  background: #f8fafc;
  font-weight: 700;
}

.scr-v2-print-payment-child td:first-child {
  padding-left: 1.5rem;
  font-weight: 400;
}

.scr-v2-print-footer {
  margin-top: 0.75rem;
  font-size: 11px;
  color: #64748b;
  text-align: right;
}

.scr-v2-print-text-danger { color: #dc3545; font-weight: 700; }
.scr-v2-print-text-success { color: #28a745; font-weight: 700; }
.scr-v2-print-text-primary { color: #e84d15; }`;
